import React from 'react';
import './styles/reviewSlider.css';
import ReviewCard from './ReviewCard';

const ReviewSlider = ({
  currentIndex,
  reviews,
  renderStars,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  handleInteractionStart,
  handleInteractionEnd,
  prevSlide,
  nextSlide
}) => {
  return (
    <>
      <div 
        className="reviews-slider"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseEnter={handleInteractionStart}
        onMouseLeave={handleInteractionEnd}
      >
        <button 
          className="slider-button prev" 
          onClick={() => {
            prevSlide();
            handleInteractionStart();
          }}
          aria-label="Previous review"
        >
          ❮
        </button>
        <ReviewCard review={reviews[currentIndex]} renderStars={renderStars} />
        <button 
          className="slider-button next" 
          onClick={() => {
            nextSlide();
            handleInteractionStart();
          }}
          aria-label="Next review"
        >
          ❯
        </button>
      </div>
      <div className="slider-dots">
        {reviews.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => {
              setCurrentIndex(index);
              handleInteractionStart();
            }}
          ></span>
        ))}
      </div>
    </>
  );
};

export default ReviewSlider;
